import React, { PureComponent } from 'react';
import axios from 'axios';
import { Row, Col } from 'reactstrap';
import authProtection from '../../HOCs/authProtection';
import LoaderSpinner from '../Widgets/LoaderSpinner';
import Alert from '../Widgets/Alert';
import withAlertTimeout from '../../HOCs/withAlertTimeout';
import SingleImageView from '../Components/SingleImageView';
import SwapPoweredImageModal from '../Components/Modals/SwapPoweredImageModal';
import buildNetlify from '../../helpers/buildNetlify';

class ViewBusinessImages extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      allAlbumImages: [],
      isLoading: false,
      successMessage: '',
      showSwapImageModal: false,
      isSwapping: false,
      selectedImageId: null,
    };
    this.getAllAlbumsData = this.getAllAlbumsData.bind(this);
    this.showSuccessNotification = this.showSuccessNotification.bind(this);
    this.showFailureNotification = this.showFailureNotification.bind(this);
    this.swapPoweredImage = this.swapPoweredImage.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderImages = this.renderImages.bind(this);
  }

  componentDidMount() {
    this.getAllAlbumsData();
  }

  async getAllAlbumsData() {
    this.setState({ isLoading: true });
    const token = sessionStorage.getItem('token');
    const headers = { headers: { Authorization: `Bearer ${token}` } };
    let allImages = [];
    const { data } = await axios.get(
      `/api/proxy/v2/businesses/${this.props.match.params.id}/albums`,
      headers
    );
    await Promise.all(
      data.items.map(async element => {
        if (element.album.rubric !== 'Shouts' && element.album.rubric !== 'Profile') {
          const { data } = await axios.get(
            `/api/proxy/v2/albums/${element.album.id}/images`,
            headers
          );
          allImages.push(...data.items);
        }
      })
    );

    this.setState({ allAlbumImages: allImages, isLoading: false });
  }

  showSuccessNotification(message) {
    this.setState({ successMessage: message });
    this.props.showSuccess();
  }

  showFailureNotification() {
    this.props.showFailure();
  }

  swapPoweredImage(currentImageID, newImageID) {
    const { id } = this.props.match.params;
    this.setState({ isSwapping: true });
    const token = sessionStorage.getItem('token');
    const headers = { headers: { Authorization: `Bearer ${token}` } };

    axios
      .put(
        `/api/proxy/v2/businesses/${id}/poweredImages/swapPowered`,
        {
          poweredImageId: currentImageID,
          replacementImageId: newImageID,
        },
        headers
      )
      .then(() => {
        this.showSuccessNotification('Powered Image Swapped.');
        this.getAllAlbumsData();
      })
      .catch(err => {
        console.log(err);
        this.showFailureNotification();
      })
      .finally(() => {
        this.closeModal();
        this.setState({ isSwapping: false });
        buildNetlify(id, token);
      });
  }

  openModal(imageID) {
    this.setState({ selectedImageId: imageID });
    this.setState({ showSwapImageModal: true });
  }

  closeModal() {
    this.setState({ showSwapImageModal: false });
  }

  renderImages() {
    return this.state.allAlbumImages.map(image => (
      <SingleImageView
        id={this.props.match.params.id}
        key={image.id}
        image={image}
        showSuccessNotification={this.showSuccessNotification}
        showFailureNotification={this.showFailureNotification}
        allImages={this.state.allAlbumImages}
        getAllAlbumsData={this.getAllAlbumsData}
        openModal={this.openModal}
      />
    ));
  }

  render() {
    if (this.state.isLoading) return <LoaderSpinner />;

    return (
      <div>
        <SwapPoweredImageModal
          key="swapImageModal"
          open={this.state.showSwapImageModal}
          itemID={this.state.selectedImageId}
          onSwap={this.swapPoweredImage}
          onClose={this.closeModal}
          buttonsDisabled={this.state.isSwapping}
          allImages={this.state.allAlbumImages}
        />
        <Alert active={this.props.success} message={this.state.successMessage} />
        <Alert
          type="danger"
          active={this.props.failure}
          message="Something went wrong, please try again"
        />

        <React.Fragment>
          {this.state.allAlbumImages.length > 0 ? (
            <div>
              <div style={{ textAlign: 'center' }}>
                <h6>Click on a powered image to copy the powered ID to the clipboard.</h6>
              </div>
              <Row>
                <Col xs="12" md="16">
                  <div className="album-grid">{this.renderImages()}</div>
                </Col>
              </Row>
            </div>
          ) : (
            <h1>This business has no images.</h1>
          )}
        </React.Fragment>
      </div>
    );
  }
}

export default authProtection(withAlertTimeout(ViewBusinessImages));



// WEBPACK FOOTER //
// ./src/views/Pages/ViewBusinessImages.js